module.exports = "/_next/static/images/0f36ebca44af52139a9ad87b8ec73b1a-slide2desktop.jpg";